import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template2.css";
import "./CheckoutTemplate2.css";

/*
   Checkout Template 2 — a seamless continuation of sales Template 2
   ("Editorial / Coal + Amber"). Reuses Template2.css directly (same
   .clp2-root design system): the real .site-nav, the dark coal .hero band
   with its noise + radial-glow treatment and serif .hero-title/.accent, the
   .btn btn--primary btn-nav-enroll button and .site-footer. Only the form +
   order-summary cards are checkout-specific (CheckoutTemplate2.css), styled
   to match the template's light editorial card look, pulled up over the hero.
*/
export default function ThankYouTemplate2({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp2-root">
      {/* NAV — same site-nav as the sales page */}
      <nav className="site-nav">
        <div className="container">
          <div className="nav-inner">
            <span className="nav-brand">
              {c.logo ? <img src={c.logo} alt="" /> : <span className="cok2-brandtext">{c.brand}</span>}
            </span>
            <span className="cok2-secure">✓ Order confirmed</span>
          </div>
        </div>
      </nav>

      {/* HERO — reuses the sales coal hero band + serif accent-word title */}
      <section className="hero cok2-hero" id="home">
        <div className="container">
          <div className="hero-content cok2-hero-content">
            <span className="cok2-eyebrow">Thank you</span>
            <h1 className="hero-title">
              You're <span className="accent">enrolled</span>
            </h1>
            {c.sub ? <p className="hero-sub">{c.sub}</p> : null}
          </div>
        </div>
      </section>

      {/* FORM + ORDER SUMMARY — in the template's editorial card style */}
      <div className="container">
        <ThankYouBody data={data} p="cok2" c={c} />
      </div>

      {/* FOOTER — same site-footer as the sales page */}
      <footer className="site-footer">
        <div className="container">
          <div className="cok2-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
